import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-employee-resign',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './employee-resign.component.html',
  styleUrl: './employee-resign.component.scss'
})
export class EmployeeResignComponent {
  
  user: any;
  ReasonLoad: any[] = []

  constructor(
    private session: SessionService,
    public common: CommonService
  ){
    this.user = session.GetUserDetails();
  }

  ngOnInit(){
    this.employee.empCode = this.user.EmpCode;
    this.employee.empName = this.user.UserName;
    this.employee.requestedDate = this.user.Date;
  }

  

  employee = {
    empCode: '',
    empName: '',
    designation: 'Developer',
    requestedDate: '',
    noticePeriod: '60 Days',
    lastWorkingDay: '25-5-2026',
    reportingManager: 'Ravi Maskar',
    photo: ''
  };

  form = {
    proposedLastWorkingDay: '',
    reason: null,
    remark: ''
  };

  onSubmit(form: any) {
    if (form.valid) {
      const payload = {
        ...this.employee,
        ...this.form
      };
      console.log(payload);
      alert('Resignation Submitted Successfully');
    }else{
      form.submitted = true;
    }
  }
}
